import { ContractLine } from '../types';

const normalizeDecimal = (value: unknown): string | null => {
  if (value == null || value === '') return null;
  return String(value).replace(',', '.');
};

const toProductId = (product: ContractLine['product']) => {
  if (product != null && typeof product === 'object') {
    const typedProduct = product as { id?: number | string | null };
    if (typedProduct.id != null) {
      return typedProduct.id;
    }
  }
  return product;
};

export const toContractPayload = (values: Record<string, unknown>) => ({
  ...values,
  ticketing_email: values.ticketing_email ?? ''
});

export const toAddContractPayload = (
  values: Record<string, unknown>,
  contractLines: ContractLine[]
) => ({
  ...values,
  lines: contractLines.map((line) => ({
    ...line,
    product: toProductId(line.product)
  }))
});

export const toContractLinePayload = (values: Record<string, any>): ContractLine => ({
  id: Math.random() * 1000000,
  product: values.product.id,
  unit_price: normalizeDecimal(values.unit_price) as string,
  initial_available_units: values.initial_available_units,
  available_units: values.initial_available_units,
  used_units: 0,
  initial_discounted_units: values.initial_discounted_units,
  available_discounted_units: values.initial_discounted_units,
  used_discounted_units: 0,
  warehouse: values.warehouse,
  iva: values.iva,
  order_notes: values.order_notes ?? '',
  has_stock_quantity: values.has_stock_quantity ?? false
});

export const toContractEquipmentPayload = (contractId: number, values: Record<string, any>) => ({
  id: crypto.randomUUID(),
  contract_header: contractId,
  equipment: values.equipment,
  preemptive_maintenance_dates: values.preemptive_maintenance_dates,
  purchase_amount: normalizeDecimal(values.purchase_amount),
  yearly_lease_amount: normalizeDecimal(values.yearly_lease_amount),
  yearly_maintenance_amount: normalizeDecimal(values.yearly_maintenance_amount),
  invoice_frequency: values.invoice_frequency?.id ?? values.invoice_frequency ?? 'YEARLY',
  annual_invoices: (() => {
    const freq = values.invoice_frequency?.id ?? values.invoice_frequency;
    if (freq === 'MONTHLY') return 12;
    if (freq === 'QUARTERLY') return 4;
    return 1;
  })(),
  depreciation_years: values.depreciation_years,
  start_date: values.start_date,
  end_date: values.end_date
});

export const toAdditionalCostPayload = (contractId: number, values: Record<string, any>) => ({
  id: crypto.randomUUID(),
  contract_header: contractId,
  code: values.code,
  description: values.description,
  date: values.date,
  amount: normalizeDecimal(values.amount),
  content_type: values.content_type,
  object_id: values.object_id
});

export const mapEquipmentOptions = (rows: any[] = []) =>
  rows.map((eq) => ({
    id: eq.id,
    code: `${eq.description} (SN ${eq.serial_number})`
  }));

export const mapSupplierOptions = (rows: any[] = []) =>
  rows.map((value) => ({
    id: value.id,
    code: `${value.code} - ${value.company_name}`
  }));

export const mapSimpleDescriptionOptions = (rows: any[] = []) =>
  rows.map((item) => ({
    id: item.id,
    code: item.description
  }));
